import { CartAddEvent } from '@theme/events';

const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

class LlShelf extends HTMLElement {
  connectedCallback() {
    const src = this.dataset.src;
    if (!src) return;
    const limit = parseInt(this.dataset.limit || '12', 10);
    fetch(src, { headers: { Accept: 'text/html' } })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = Array.from(doc.querySelectorAll('[data-ll-shelf-items] .ll-card')).slice(0, limit);
        if (cards.length) this.replaceChildren(...cards.map((card) => document.importNode(card, true)));
      })
      .catch(() => {})
      .finally(() => this.classList.remove('is-loading'));
  }
}

if (!customElements.get('ll-shelf')) customElements.define('ll-shelf', LlShelf);

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-ll-quick-add')) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const label = button ? button.textContent : '';
  if (button) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
  }
  try {
    const formData = new FormData(form);
    const addResponse = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    const added = await addResponse.json();
    if (!addResponse.ok || added.status) throw new Error(added.description || added.message || 'Add failed');
    const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
    form.dispatchEvent(
      new CartAddEvent(cart, form.id || 'll-quick-add', {
        source: 'll-quick-add',
        itemCount: cart.item_count,
        variantId: String(formData.get('id')),
      })
    );
    if (button) {
      button.textContent = button.dataset.addedLabel || label;
      button.classList.add('is-added');
      setTimeout(() => {
        button.textContent = label;
        button.classList.remove('is-added');
      }, 2000);
    }
  } catch (error) {
    form.removeAttribute('data-ll-quick-add');
    form.submit();
  } finally {
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
});

const LL_PRICE_KEY = 'll-min-price-v1';
const LL_PRICE_TTL = 10 * 60 * 1000;

function llApplyMinPrice(cents) {
  if (!Number.isFinite(cents) || cents <= 0) return;
  const text = `$${(cents / 100).toFixed(2)}`;
  document.querySelectorAll('[data-ll-min-price]').forEach((el) => {
    if (el.textContent !== text) el.textContent = text;
  });
}

async function llRefreshMinPrice() {
  if (!document.querySelector('[data-ll-min-price]')) return;
  try {
    const cached = JSON.parse(sessionStorage.getItem(LL_PRICE_KEY) || 'null');
    if (cached && Date.now() - cached.t < LL_PRICE_TTL) {
      llApplyMinPrice(cached.cents);
      return;
    }
  } catch (e) {}
  try {
    const url = `${root}collections/all?sort_by=price-ascending&filter.v.availability=1&section_id=ll-min-price`;
    const html = await (await fetch(url, { headers: { Accept: 'text/html' } })).text();
    const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ll-min-price-live]');
    if (!node) return;
    if (node.dataset.currencyOk !== 'true' || node.dataset.available !== 'true' || node.dataset.sort !== 'price-ascending') return;
    const cents = parseInt(node.dataset.cents || '', 10);
    if (!Number.isFinite(cents) || cents <= 0) return;
    sessionStorage.setItem(LL_PRICE_KEY, JSON.stringify({ cents, t: Date.now() }));
    llApplyMinPrice(cents);
  } catch (e) {}
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', llRefreshMinPrice);
} else {
  llRefreshMinPrice();
}
